import React, { Fragment, useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";

import Profile from "./pages/Profile";
import Login from "./pages/Login";
import Wallets from "./pages/Wallets";
import CoinWallet from "./pages/CoinWallet";
import ReviewTransaction from "./pages/ReviewTransaction";
import ConfirmTransaction from "./pages/ConfirmTransaction";
import ViewTransactionDetail from "./pages/ViewTransactionDetail";
import Swaps from "./pages/Swaps";
import ReviewSwap from "./pages/ReviewSwap";
import ConfirmSwap from "./pages/ConfirmSwap";
import ViewSwapDetail from "./pages/ViewSwapDetail";
import Users from "./pages/Users";
import Announcements from "./pages/Announcements";
import ViewUserDetail from "./pages/ViewUserDetail";
import ViewReferrals from "./pages/Users/ViewReferrals";
import Orders from "./pages/Orders";
import ReviewOrder from "./pages/ReviewOrder";
import Configurations from "./pages/Configurations";
import Settings from "./pages/Settings";
import UpdatePassword from "./pages/UpdatePassword";
import UpdatePin from "./pages/UpdatePin";
import ProtectedRoute from "./utils/ProtectedRoute";
import Referrals from "./pages/Referrals";
import ViewReferral from "./pages/ViewReferral";
import Miners from "./pages/Miners/index";
import CustomReferralCode from "./pages/CustomReferralCode";
import CustomReferralCodeForm from "./pages/CustomReferralCode/Form";
import CustomAdminReferralCode from "./pages/CustomReferralCode/ViewReferrals";
import DWRequests from "./pages/DWRequest";
import DWRequestEdit from "./pages/DWRequest/edit";
import GiftCards from "./pages/GiftCards";
import GiftCardTransactions from "./pages/GiftCardTransactions";
import GiftCardTransactionsForm from "./pages/GiftCardTransactions/Form";
import VirtualCardUsers from "./pages/VirtualCards";
import VirtualCardList from "./pages/VirtualCards/cardList";
import VirtualCardUserForm from "./pages/VirtualCards/Form";

const AppRoutes = () => {
  return (
    <Fragment>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route
          path="/profile"
          element={<ProtectedRoute Component={Profile} />}
        />
        <Route path="/miners" element={<ProtectedRoute Component={Miners} />} />
        <Route
          path="/wallets"
          element={<ProtectedRoute Component={Wallets} />}
        />
        <Route path="/coinWallet" element={<CoinWallet />} />
        <Route
          path="/reviewTransaction"
          element={<ProtectedRoute Component={ReviewTransaction} />}
        />
        <Route
          path="/confirmTransaction"
          element={<ProtectedRoute Component={ConfirmTransaction} />}
        />
        <Route
          path="/viewTransactionDetail"
          element={<ProtectedRoute Component={ViewTransactionDetail} />}
        />
        <Route path="/swaps" element={<ProtectedRoute Component={Swaps} />} />
        <Route
          path="/reviewSwap"
          element={<ProtectedRoute Component={ReviewSwap} />}
        />
        <Route
          path="/confirmSwap"
          element={<ProtectedRoute Component={ConfirmSwap} />}
        />
        <Route
          path="/viewSwapDetail"
          element={<ProtectedRoute Component={ViewSwapDetail} />}
        />
        <Route path="/users" element={<ProtectedRoute Component={Users} />} />
        <Route
          path="/announcements"
          element={<ProtectedRoute Component={Announcements} />}
        />
        <Route
          path="/viewUserReferral"
          element={<ProtectedRoute Component={ViewReferrals} />}
        />
        <Route
          path="/viewUserDetail"
          element={<ProtectedRoute Component={ViewUserDetail} />}
        />
        <Route path="/orders" element={<ProtectedRoute Component={Orders} />} />
        <Route
          path="/reviewOrder"
          element={<ProtectedRoute Component={ReviewOrder} />}
        />
        <Route
          path="/config"
          element={<ProtectedRoute Component={Configurations} />}
        />
        <Route
          path="/settings"
          element={<ProtectedRoute Component={Settings} />}
        />
        <Route
          path="/updatePassword"
          element={<ProtectedRoute Component={UpdatePassword} />}
        />
        <Route
          path="/updatePin"
          element={<ProtectedRoute Component={UpdatePin} />}
        />
        <Route
          path="/referrals"
          element={<ProtectedRoute Component={Referrals} />}
        />
        <Route
          path="/viewReferral"
          element={<ProtectedRoute Component={ViewReferral} />}
        />
        <Route
          path="/CustomReferralCode"
          element={<ProtectedRoute Component={CustomReferralCode} />}
        />
        <Route
          path="/viewAdminReferral"
          element={<ProtectedRoute Component={CustomAdminReferralCode} />}
        />
        <Route
          path="/CustomReferralCode/Form"
          element={<ProtectedRoute Component={CustomReferralCodeForm} />}
        />
        <Route
          path="/CustomReferralCode/Form/:id"
          element={<ProtectedRoute Component={CustomReferralCodeForm} />}
        />
        <Route
          path="/dw-requests"
          element={<ProtectedRoute Component={DWRequests} />}
        />
        <Route
          path="/dw-requests/edit/:id"
          element={<ProtectedRoute Component={DWRequestEdit} />}
        />
        <Route
          path="/gift-cards"
          element={<ProtectedRoute Component={GiftCards} />}
        />
        <Route
          path="/gift-card-transactions"
          element={<ProtectedRoute Component={GiftCardTransactions} />}
        />
        <Route
          path="/gift-card-transactions/edit/:id"
          element={<ProtectedRoute Component={GiftCardTransactionsForm} />}
        />
        <Route
          path="/virtual-card-users"
          element={<ProtectedRoute Component={VirtualCardUsers} />}
        />
        <Route
          path="/virtual-card-user/edit/:id"
          element={<ProtectedRoute Component={VirtualCardUserForm} />}
        />
        <Route
          path="/virtual-cards"
          element={<ProtectedRoute Component={VirtualCardList} />}
        />
      </Routes>
    </Fragment>
  );
};

export default AppRoutes;
